import { useMemo } from "react";
import { defaultLocaleText } from "../../defaultLocaleText.js";
function useTexts(localeText) {
  return useMemo(
    () => ({
      ...defaultLocaleText,
      ...localeText
    }),
    [localeText]
  );
}
export {
  useTexts
};
//# sourceMappingURL=useTexts.js.map
